import React from 'react';

import { contactStrings } from '@data/contacts';
import { ContactForm } from '@models/Contact';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  instructionContactDisplay: {
    ...common.backgroundPrimaryAlpha3,
    ...common.middleText,
    ...common.textGray700,
    padding: '15px 30px',
    wordBreak: 'break-all',
    '&$stale *[role="data"]': {
      textDecoration: 'line-through',
    },
  },
  stale: {},
}));

export interface InstructionContactDisplayProps {
  contact: Omit<ContactForm, 'user'>;
  stale?: boolean;
}

export const InstructionContactDisplay: React.FC<InstructionContactDisplayProps> = ({
  contact,
  stale,
}) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const renderPlaceholder = (label: string) => {
    return <span className={classes.textGray500}>{label}…</span>;
  };

  const renderDataOrPlaceholder = (key: keyof typeof contact) => {
    return (
      <>
        {contact[key] ? (
          <span role="data">{contact[key]}</span>
        ) : (
          renderPlaceholder(contactStrings[key])
        )}
      </>
    );
  };

  return (
    <div className={clsx(classes.instructionContactDisplay, stale && classes.stale)}>
      <div className={clsx(classes.textGray900, classes.normalText)}>
        <b role="data">{contact.company_name}</b>
      </div>
      <div className={clsx(classes.textGray500, classes.normalText)} style={{ marginBottom: 8 }}>
        {renderDataOrPlaceholder('english_name')}
      </div>

      <div>
        {contact.zip_code ? (
          <span role="data">〒{contact.zip_code}</span>
        ) : (
          renderPlaceholder(contactStrings.zip_code)
        )}
      </div>
      <div>{renderDataOrPlaceholder('address1')}</div>
      <div>{renderDataOrPlaceholder('address2')}</div>
      <div>{renderDataOrPlaceholder('principal_name')}</div>
      <div>{renderDataOrPlaceholder('phone')} </div>

      <div className={classes.backgroundPrimaryAlpha10} style={{ height: 1, margin: '8px 0' }} />

      <div>{renderDataOrPlaceholder('email')}</div>
      <div>{renderDataOrPlaceholder('sns_id')}</div>
    </div>
  );
};
